// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v717demo1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  //url: 'https://mlicportalapi.azurewebsites.net',
url: "https://micaseguradosapi.azurewebsites.net",
  //url: 'http://dnsdesa03.eastus.cloudapp.azure.com:61921/SF.YoSeguroInsuredProducerLife.Api',
  apiUrl: 'api',

  urlTest: "",

  autoplayTimeout: 4000,
  modalLoadingConfig: { keyboard  : false, backdrop : 'static'},

  title: "",

  showWelcomeTitle : false,
}; 

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
